import React, { Component } from "react";
import { Alert } from '../Utils/Alert';
import './Style.css';
import '../../custom.css'
import { Loading } from '../Utils/Loading';
export class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isPost: false,
            loading: false,
            alert: {
                Title: '',
                Body: '',
                Type: '',
                Show: false
            },
            model: {
                Email: '',
                Password: ''
            }
        }
    }

    render() {
        return (

            <div className="wrapp-login row">
                <div className="col-lg-6">
                    <img src={require('../../images/login.jpg')} className="w-100 p-0" />
                </div>
                <div className="col-lg-6">
                    <div className="form card">

                        <div className="text-center mb-5"><a href="/"><img src={require('../../icon/LogoLife.png')} style={{ width: 60 }} /></a></div>

                        <div className="form-group">
                            {this.state.isPost && !this.state.model.Email ? <span className="required">
                                *
                            </span> : null}
                            <label> Documento de identidad</label>
                            <input type="text" name="email" className="form-control p-10" onChange={(e) => {

                                var model = this.state.model;
                                model.Email = e.currentTarget.value;

                                this.setState({ model })
                            }} />
                        </div>


                        <div className="form-group">
                            {this.state.isPost && !this.state.model.Password ? <span className="required">
                                *
                            </span> : null}
                            <label>Contraseña</label>
                            <input type="password" name="pass" className="form-control p-10" onChange={(e) => {

                                var model = this.state.model;
                                model.Password = e.currentTarget.value;

                                this.setState({ model })
                            }} />
                        </div>

                        <div className="form-group">
                            <input type="button" value="Enviar" className="btn btn-primary" onClick={(e) => { this.login() }} />
                        </div>
                    </div>
                </div>

                {this.state.alert.Show ? <Alert Title={this.state.alert.Title} Type={this.state.alert.Type} Body={this.state.alert.Body} callBack={() => { this.setState({ alert: { show: false } }) }} /> : null}
                {this.state.loading ? <Loading /> : null}
            </div>
        )
    }

    async login() {

        var isPost = this.state.isPost;
        isPost = true;
        this.setState({ isPost })

        if (!this.state.model.Email || !this.state.model.Password) {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Los campos marcados con asterisco (*) son obligatorios',
                    Type: 'alert-danger',
                    Show: true
                }
            });
            return;
        }


        var request = {
            method: 'POST',
            headers: { 'Content-type': 'application/json' },
            body: JSON.stringify(this.state.model)
        }
        this.setState({ loading: true });
        const response = await fetch('Login/Authenticate', request);
        this.setState({ loading: false });

        if (response.status == 200) {
            const data = await response.json();
            localStorage.setItem('token', data.token);
            window.location.href = '/';
        } else {
            this.setState({
                alert: {
                    Title: 'Error',
                    Body: 'Usuario y/o contraseña inválidos.',
                    Type: 'alert-danger',
                    Show: true
                }
            });
        }
    }
}